<template>
  <div id="header">
      <div id="logo">
          <img class="img" src="../assets/logo.png"> 

<div id="menu">
<el-menu class="el-menu-demo" id="nav" mode="horizontal"  :default-active="getActive" router>
<template v-for="item in menus"  >
<el-submenu :index="item.type" v-if="item.children !=null && item.id !=6" :key="item.id" class="menuItem">
<template slot="title" >{{item.name}}</template>
<el-menu-item v-for="child in item.children" :index="item.type" :key="child.id" :route="{ path: item.type, query: { id: child.type } }" class="chMenuItem" mode="horizontal">{{child.name}}</el-menu-item>
</el-submenu>
<el-menu-item v-if="item.children ==null" :key="item.type" :index="item.type">{{item.name}}</el-menu-item>
<el-menu-item v-if="item.id==6" :key="item.type" :index="item.type" >{{item.name}}</el-menu-item>
<!-- <el-menu-item v-if="item.id ==6" :key="item.type" :index="item.type" :route="{ path: item.type, query: { id: child.type } }">{{item.name}}</el-menu-item> -->
</template>
</el-menu>

    </div>


<div id="link"> 
<img  style="margin-right:10px" src="../assets/weibo.png"> 
<img  src="../assets/douyin.png"> 
</div>
    
    </div>
  </div>
</template>

<script>
import { getRequest } from '../util/api'

export default {
  data() {
    return {
       menus: [],
    }
  },
  props: {

  },
  mounted() {
    this.getMenu()
  },
  computed: {
    getActive: function() {
     
      var path = this.$route.path.split('/')
      return path[1]
    }
  },
  methods: {
    getMenu() {
      let that = this
      getRequest('/menus/list').then(function(res) {
        if (res.data.meta.code == 1) {
          that.menus = res.data.data
        }
      })
    }
  }
}
</script>

<style >


.el-menu--popup-bottom-start {
    margin-top: -20px !important;
    height: 30px;
}
.chMenuItem{
  display: inline;
}

#header {
  width: 99%;
  height: 83px;
  padding-top: 17px;
}

#logo {
  width: 80%;
  height: 67px;
  line-height: 67px;
  margin-top: 34px;
  position: relative;
  margin: auto;
  text-align: center;
}
.img {
  position: absolute;
  left: 0%;
}

#menu {
  position: absolute;
  right: 10%;
  top: 0;
  width:60%
}
#link {
  position: absolute;
  right: 0px;
  top: 0;

}

#nav {
  font-family: 'Source Han Sans SC';
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  border-bottom: 0px !important;
}

.el-menu--horizontal >.el-menu-item {
padding: 0 10px;
font-family: 'Source Han Sans SC';
font-style: normal;
font-weight: 400;
font-size: 14px;
}
.el-submenu__title {
  padding: 0px 12px !important;
  font-weight: 400;
  font-size: 14px;
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0px solid transparent !important;
    color: #3199E9 !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  color: #3199E9 !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: 0px solid transparent !important;
    color: #3199E9 !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    outline: 0;
     color: #3199E9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue